






















































































































































































































import { ApexOptions } from "apexcharts";
import { Dictionary } from "lodash";
import moment from "moment";
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import {
  CustomersApi,
  NotificationModel,
  NotificationsApi,
  RpasApi,
  TreatmentMonitoringApi,
  TreatmentMonitoringDetailModel,
  TreatmentRequestModel,
  TreatmentRequestsApi,
  UnitModel,
  UnitsApi,
  VariableChartDataModel,
  VariableDataModel,
  VariableModel,
  VariablesApi,
} from "../../../apis";
import DataLog from "./DataLog.vue";
import ProcessTime from "./ProcessTime.vue";
import StatusParam from "./StatusParam.vue";
import Params from "./Param.vue";
import Calibration from "./Calibration.vue";
import Alarm from "./Alarm.vue";
import TreatmentGraphV4 from "./TreatmentGraphV4.vue";
import {
  DUMMY_CHART,
  ITreatmentMonitoring,
  ITreatmentMonitoringDetail,
} from ".";
import { deepCopy } from "deep-copy-ts";
import TrackState from "../../../views/mixin/TrackState.vue";
import { mixins } from "vue-class-component";
@Component({
  components: {
    DataLog,
    ProcessTime,
    StatusParam,
    Calibration,
    Params,
    Alarm,
    TreatmentGraphV4
  },
})
export default class TreatmentMonitoringDetail extends mixins(TrackState) {
  @Ref("graph") readonly graph!: InstanceType<typeof TreatmentGraphV4>;

  isShowAlarmDialog = false;
  isShowStatusDialog = false;
  isShowParamDialog = false;
  isShowCaliParamDialog = false;
  isShowTimeDialog = false;
  isShowDataLogDialog = false;

  panels = [];
  alarms: NotificationModel[] = [];
  alarmPage = 1;
  alarmCount = 0;
  alarmLimit = 10;
  /////
  selectedNumericParam: string[] = [];
  selectedBoolParam: string[] = [];
  selectedUnit: UnitModel = null;
  variables: VariableModel[] = [];

  treatments: TreatmentRequestModel[] = [];
  showRecountConfimDialog: boolean = false;
  recountFollowTreatmentDatabase = false;
  recountDate = "";
  intervalId: any = null;
  customerName: string = "";
  isShowOverview: boolean = true;

  get TREATMENTS() {
    return !this.treatments
      ? []
      : this.treatments.map((val) => ({
          value: val.id,
          text: val.number,
        }));
  }
  mounted() {
    this.isShowOverview = !this.$screen.isMobile();
    this.$nextTick(() => {
      setTimeout(() => {
      if (this.selectedUnit && this.selectedUnit.name){
        document.title = this.selectedUnit.name + "- "+ this.selectedUnit.location.locationName + "- "  + this.$t("route.treatment.monitoring_detail");
      }
      }, 3000);
    });
  }
  clearInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    if (this.intervalIdGraph) {
      clearInterval(this.intervalIdGraph);
      this.intervalIdGraph = null;
    }
  }

  beforeDestroy() {
    this.clearInterval();
  }

  get NUMERIC_PARAMERTERS() {
    return !this.variables
      ? []
      : this.variables
          .filter((val) => ["BYTE", "UBYTE", "WORD" , "FLOATING"].includes(val.type))
          .map((val) => {
            return {
              value: val.id,
              text: val.variableName,
              color: this.generateRandomColor(),
            };
          });
  }

  get OPERATIONTIME_PARAMERTERS() {
    return !this.variables
      ? []
      : this.variables
          .filter((val) => val.operationTime)
          .map((val) => {
            return {
              value: val.id,
              text: val.variableName,
              color: this.generateRandomColor(),
            };
          });
  }

  generateRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  created() {
    if (
      (this as any).$hasPermission({
        context: "TREATMENT_MONITORING_FOR_UNIT|RECOUNT_TREATMENT_TIME",
        action: "update",
      })
    ) {
      this.recountTask();
    }
    const { id: unitId } = this.$route.params;
    new TreatmentMonitoringApi()
      .getTreatmentRunningByUnit({
        unitId,
      })
      .then((resp) => {
        this.treatments = resp.data.data;
      });

    new UnitsApi().getUnitById({ id: unitId }).then((resp) => {
      this.selectedUnit = resp.data.data;
      if (this.selectedUnit && this.selectedUnit.name){
        document.title = this.selectedUnit.name + "- "+ this.selectedUnit.location.locationName + "- "  + this.$t("route.treatment.monitoring_detail");
      }
      this.getAlarms();
      this.getCustomer();
    });
    new VariablesApi()
      .getVariablesByUnitId({
        id: unitId,
      })
      .then((resp) => {
        this.variables = resp.data.data;
      });
  }

  intervalIdGraph = null;
  intervalSearch(){
    if (this.graph){
      this.graph.doSearch('auto');
    }
  }
  onLoad() {
    this.intervalIdGraph = setInterval(() => {
        if(!(this as any)._isDestroyed) this.intervalSearch();
    }, 300000);
  }

  getCustomer() {
    new CustomersApi()
      .getCustomerById({ id: this.selectedUnit.location.customerId })
      .then((resp) => {
        const {
          data: {
            data: { companyName },
          },
        } = resp;
        this.customerName = companyName;
      });
  }
    async checkRecount() {
    const { id: unitId } = this.$route.params;
    const {
      data: { data },
    } = await new TreatmentRequestsApi().checkRecount({
      unitId,
    });
    if ((this as any)._isDestroyed) return;
    if (data) {
      this.showRecountConfimDialog = true;
    }
  }
  recountTask() {
    this.checkRecount();
    this.intervalId = setInterval(() => {
        if (!(this as any)._isDestroyed) this.checkRecount();
    }, 150000);
  }

  async onRecount() {
    this.$util.showLoading();
    try {
      await new RpasApi().recountRPA({
        id: this.selectedUnit.id,
      });
      this.showRecountConfimDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onContinue() {
    this.$util.showLoading();
    try {
      await new RpasApi().continueRPA({
        id: this.selectedUnit.id,
      });
      this.showRecountConfimDialog = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  getAlarms(reset?: boolean) {
    const { id: unitId } = this.$route.params;
    new NotificationsApi()
      .getAlarmNotificationsByUnit({
        unitId: unitId,
      })
      .then((resp) => {
        if (reset) this.alarms = resp.data.data;
        else this.alarms = this.alarms.concat(resp.data.data);
        this.alarmCount = resp.data.count;
      });
  }
  handleAlarmClick(event) {
    if (event.target && event.target.classList.contains("treatment-notification")) {
      const code: string = event.target.getAttribute("code");
      if ([ "TREATMENT_START", "TREATMENT_STOP", "TREATMENT_RECOUNT", "TREATMENT_REACHED", "TREATMENT_REACHED_ALL", "TREATMENT_OUT_OF_REACH" ].includes(code)) {
        this.$router.replace({
          name: "monitoring-detail",
          params: { id: event.target.getAttribute("unitId") || "" },
          query: { t: "" + new Date().getTime() },
        });
      } else {
        this.$router.replace({
          name: "view-treatment-request",
          params: { id: event.target.getAttribute("treatmentId") },
          query: { t: "" + new Date().getTime() },
        });
      }
    }
  }
  getAlarm(item: NotificationModel) {
    const param = {};
    item.params.forEach((val: { field: string; value: string }) => {
      if (val.field === "dateTime")
        param[val.field] = moment
          .utc(val.value, "YYYY-MM-DD HH:mm:ss")
          .local()
          .format("YYYY-MM-DD HH:mm");
      else param[val.field] = val.value;
    });
    return "- " + this.$t(`notification.type.${item.code}`, param);
  }

  onChangeAlarm() {
    if (this.panels.length === 1) {
      return;
    }
    this.alarmPage = 1;
    this.getAlarms(true);
  }
  infiniteScrolling(entries, observer, isIntersecting) {
    if (!isIntersecting) {
      return;
    }
    // setTimeout(() => {
    if (!document.querySelector(".alarm-waning.expand-transition-enter")) {
      this.alarmPage++;
      this.getAlarms();
    }
    // }, 500);
  }
}
